<template>
  <div class="card shadow h-100">
    <div class="card-header bg-transparent border-0">
      <h6>Cadastro</h6>
    </div>
    <div class="card-body">
      <div class="alert alert-warning fade show" role="alert" v-show="showAlerts">
        <div v-for="(alert, i) in alerts" v-bind:key="i">{{alert}}</div>
      </div>
      <div class="alert alert-danger fade show" role="alert" v-show="showErrors">
        <div v-for="(erro, i) in erros" v-bind:key="i">{{erro}}</div>
      </div>
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
          <div class="form-group">
            <label class="col-form-label-sm label-input" for="cnpjEmpresa">CNPJ Empresa:</label>
            <input
              class="form-control form-control-sm"
              id="cnpjEmpresa"
              v-mask="'##.###.###/####-##'"
              v-model="input.cnpj"
              @change="getNomeEmpresa()"
            />
          </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
          <div class="form-group">
            <label class="col-form-label-sm label-input" for="nomeEmpresa">Nome Empresa:</label>
            <input
              type="text"
              class="form-control form-control-sm"
              id="nomeEmpresa"
              v-model.trim="input.nomeEmpresa"
            />
          </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
          <div class="form-group">
            <label class="col-form-label-sm label-input" for="inicioVigencia">Inicio Vigência:</label>
            <input
              class="form-control form-control-sm"
              v-mask="'##/####'"
              id="'inicioVigencia'"
              v-model="input.dataInicioVigencia"
            />
          </div>
        </div>

        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
          <div class="form-group">
            <label class="col-form-label-sm label-input" for="fimVigencia">Fim Vigência:</label>
            <input
              class="form-control form-control-sm"
              v-mask="'##/####'"
              id="'fimVigencia'"
              v-model="input.dataFimVigencia"
            />
          </div>
        </div>

        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
          <div class="form-group">
            <label
              class="col-form-label-sm label-input"
              for="valorRemuneracao"
            >Utilizar Teto de INSS :</label>
            <div>
              <button
                type="button"
                :class="input.aceitarTetoINSS ? 'btn btn-outline-success btn-block' : 'btn btn-outline-dark btn-block'"
                @click="utilizaTetoInss()"
              >
                <li :class="input.aceitarTetoINSS ? 'oi oi-task' : 'oi oi-plus'" />
                {{btnAceitarTetoInss}}
              </button>
            </div>
          </div>
        </div>

        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
          <div class="form-group">
            <label
              class="col-form-label-sm label-input"
              for="valorRemuneracao"
            >Valor Remuneração Base INSS:</label>
            <money
              v-model="input.baseInss"
              class="form-control form-control-sm"
              v-bind:id="'valorRemuneracao'"
              :disabled="input.aceitarTetoINSS"
            />
          </div>
        </div>
      </div>
      <br />

      <br />

      <br />
      <button class="btn btn-outline-dark" @click="limpar()">
        <li class="oi oi-ban"></li>Limpar
      </button>
      <button class="btn btn-secondary" @click="salvarDeclaracao()" :disabled="carregando">
        <li class="oi oi-check"></li>Salvar
      </button>
    </div>
  </div>
</template>

<script>
import competencia from "../../utils/InputCompetencia";
import cnpj from "../../utils/InputCnpj";
import http from "./../../../axios";
import { CNPJ } from "cpf_cnpj";
import { mask } from "vue-the-mask";
import modal from "../../utils/Modal";
import moment from "moment"
export default {
  name: "DeclaracaoInssCadastroDetalhado",
  components: { competencia: competencia, cnpj: cnpj, modal: modal },
  data() {
    return {
      input: {
        cnpj: "",
        nomeEmpresa: "",
        baseInss: "",
        entidade: "",
        cooperado: "",
        dataInicioVigencia: "",
        dataFimVigencia: "",
        aceitarTetoINSS: false,
        valorTeto: 0,
        termoResponsabilidade : "",
        bloquearCompetenciaAtual : false
      },
      listaEntidade: [],
      isModalVisible: false,
      carregando: false,
      showErrors: false,
      erros: [],
      showAlerts: false,
      alerts: [],
      tokens: {}
    };
  },
  directives: { mask },
  created: function() {
    this.init();
  },
  methods: {
    init: function() {
      this.getTokens();
      this.initDadosInsert();
    },
    utilizaTetoInss() {
      this.input.aceitarTetoINSS = !this.input.aceitarTetoINSS;
      if (this.input.aceitarTetoINSS) {
        this.input.baseInss = this.input.valorTeto;
      } else {
        this.input.baseInss = 0;
        this.input.valorInss = 0;
      }
    },    
    initDadosInsert: function() {
      http
        .get(`api/declaracao/insert/dados/${this.tokens.id}`, {
          headers: { "token-cooperado-api": this.tokens.token }
        })
        .then(r => {
          if (r.data.statusCode == 200) {
            if(r.data.result.listaEntidade.length > 0){
              this.listaEntidade = r.data.result.listaEntidade; 
              this.input.entidade = this.listaEntidade[0].pk_entidade_sasc;
            }else{
              this.listaEntidade = undefined;
              this.input.entidade = undefined;
            }
            this.input.valorTeto = r.data.result.tetoInss[0].valor_teto_inss;
            this.input.termoResponsabilidade = r.data.result.termoResponsabilidade[0];
            this.alerts.push(r.data.result.dataBloqueio[0].mensagem);
            this.showAlerts = this.alerts.length > 0;
            this.bloquearCompetenciaAtual = r.data.result.dataBloqueio[0].bloquear;
          } else {
            this.listaEntidade = undefined;
            this.input.entidade = undefined;
          }
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status >= 500) {
              this.$router.push("/");
            }
          } else if (error.request) {
            this.$router.push("/");
          } else {
            console.log("Error", error.message);
            this.$router.push("/");
          }
        });
    },
    getNomeEmpresa: function() {
      if (CNPJ.isValid(this.cnpjSemMask)) {
        http
          .get(`api/empresa/${this.cnpjSemMask}`, {
            headers: { "token-cooperado-api": this.tokens.token }
          })
          .then(r => {
            if (r.data.statusCode == 200) {
              this.input.nomeEmpresa = r.data.result[0].nome;
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status >= 500) {
                this.$router.push("/");
              }
            } else if (error.request) {
              this.$router.push("/");
            } else {
              console.log("Error", error.message);
              this.$router.push("/");
            }
          });
      }
    },
    salvarDeclaracao: function() {
      this.$Progress.start();
      this.carregando = true;
      this.salvarAntes();
      if (!this.showErrors) {
        var objeto = {
          cnpj: this.cnpjSemMask,
          nomeEmpresa: this.input.nomeEmpresa,
          baseInss: this.input.baseInss,
          entidade: this.input.entidade,
          cooperado: this.tokens.id,
          dataInicioVigencia: this.dataInicioFormatJson,
          dataFimVigencia: this.dataFimFormatJson
        };
        http
          .post(`api/cooperado/declaracao/insert`, objeto, {
            headers: { "token-cooperado-api": this.tokens.token }
          })
          .then(r => {
            if (r.data.statusCode == 200) {
              this.carregando = false;
              this.$router.push("/DeclaracaoInssLista");
              this.$Progress.finish();
            }
          })
          .catch(error => {
            console.log(error);
            this.$Progress.fail();
            this.carregando = false;
            if (error.response) {
              if (error.response.status >= 500) {
                this.$router.push("/");
              } else {
                if (error.response.status == 400) {
                  for (var i in error.response.data.result) {
                    this.erros.push(error.response.data.result[i]);
                  }
                  if (this.erros.length > 0) {
                    this.showErrors = true;
                  }
                }
              }
            } else if (error.request) {
              this.$router.push("/");
            } else {
              console.log("Error", error.message);
              this.$router.push("/");
            }
          });
      } else {
        this.carregando = false;
        this.$Progress.fail();
      }
    },
    getTokens: function() {
      this.tokens = this.$cooperadowebapi.tokens.get("usuario");
    },
    salvarAntes: function() {
      this.showErrors = false;
      this.erros = [];

      if (this.listaEntidade == undefined || this.listaEntidade.length == 0) {
        this.erros.push("Cooperado não se encontra ativo em uma Cooperativa");
      } else {
        if (this.cnpjSemMask == undefined || this.cnpjSemMask.length == 0) {
          this.erros.push("CNPJ não informado");
        } else {
          if (!CNPJ.isValid(this.cnpjSemMask)) {
            this.erros.push("CNPJ informado inválido");
          }
        }
        if (
          this.input.nomeEmpresa == "" &&
          this.input.nomeEmpresa.length == 0
        ) {
          this.erros.push("Nome Empresa não informado");
        }

        if (
          this.input.dataInicioVigencia == "" &&
          this.input.dataInicioVigencia.length == 0
        ) {
          this.erros.push("Inicio Vigência não informado");
        } else {
          if (!this.dataValida(this.input.dataInicioVigencia)) {
            this.erros.push("Inicio Vigência inválido");
          }
        }

        if (
          this.input.dataFimVigencia == "" &&
          this.input.dataFimVigencia.length == 0
        ) {
          this.erros.push("Fim Vigência não informado");
        } else {
          if (!this.dataValida(this.input.dataFimVigencia)) {
            this.erros.push("Fim Vigência inválido");
          }
        }

        if (this.input.baseInss == 0) {
          this.erros.push("Valor Remuneração Base INSS não informado");
        } else {
          if (
            this.input.baseInss > 0 &&
            this.input.baseInss > this.input.valorTeto
          ) {
            this.erros.push(
              `Valor Remuneração Base INSS maior que o valor do teto do INSS de ${Vue.filter(
                "formatMoney"
              )(this.input.valorTeto)}`
            );
          }
        }

        if (
          this.input.entidade == undefined ||
          this.input.entidade == "" ||
          this.input.entidade.length == 0
        ) {
          this.erros.push("Cooperativa Responsável não informado");
        }
      }

      this.showErrors = this.erros.length > 0;
    },
    limpar: function() {
      this.showErrors = false;
      this.erros = [];
      (this.input.cnpj = ""),
        (this.input.nomeEmpresa = ""),
        (this.input.baseInss = ""),
        (this.input.entidade = ""),
        (this.input.cooperado = ""),
        (this.input.dataInicioVigencia = ""),
        (this.input.dataFimVigencia = "")
    },
    dataValida: function(data) {
      var valido = false;
      try {
        if (data != undefined && data.length == 7) {
          const mes = data.substring(0, 2);
          const ano = data.substring(3, 7);
          if (parseInt(mes) >= 1 && parseInt(mes) <= 12) {
            if (parseInt(ano) >= 1900 && parseInt(ano) <= 2100) {
              valido = true;
            }
          }
        }
      } catch (e) {
        valido = false;
      }
      return valido;
    },
    dateFormatString: function(data) {
      try {
        const mes = data.substring(0, 2);
        const ano = data.substring(3, 7);
        const dataInicio = new Date(
          parseInt(ano),
          parseInt(mes) - 1,
          1,
          0,
          0,
          0,
          0
        );
        return ano + "-" + mes + "-01";
      } catch (e) {
        return undefined;
      }
    }
  },
  computed: {
    btnAceitarTetoInss: function() {
      return !this.input.aceitarTetoINSS
        ? `Utilizar teto de INSS de ${Vue.filter("formatMoney")(
            this.input.valorTeto
          )}`
        : `Teto de INSS de ${Vue.filter("formatMoney")(
            this.input.valorTeto
          )} utilizado`;
    },
    cnpjSemMask: function() {
      return this.input.cnpj.replace(/[^\d]+/g, "");
    },
    dataInicioFormatJson: function() {
      const mes = this.input.dataInicioVigencia.substring(0, 2);
      const ano = this.input.dataInicioVigencia.substring(3, 7);
      return ano + "-" + mes + "-01";
    },
    dataFimFormatJson: function() {
      const mes = this.input.dataFimVigencia.substring(0, 2);
      const ano = this.input.dataFimVigencia.substring(3, 7);
      return ano + "-" + mes + "-01";
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/declaracao/DeclaracaoInssCadastroDetalhado.vue